/* ============================================================
   arthene — Werke auf der Künstlerseite

   Liquid kann Produkte nicht nach dem Feld „Anbieter" durchsuchen. Shopify
   kann es über eine eingebaute Adresse: /collections/vendors?q=Name. Diese
   Datei holt sich von dort das Bruchstück, das templates/collection.werke
   ausgibt, und setzt es unter die Biografie.

   Ohne JavaScript bleibt der Knopf „Alle Werke von …" darunter stehen und
   führt auf dieselbe Adresse — die Seite ist also auch dann vollständig
   bedienbar, nur ohne Vorschau.
   ============================================================ */
(function () {
  'use strict';

  function laden(block) {
    if (block.dataset.geladen === '1') return;
    block.dataset.geladen = '1';

    var name = block.getAttribute('data-name');
    var buehne = block.querySelector('[data-kwerke-buehne]');
    var anzeige = block.querySelector('[data-kwerke-anzahl]');
    if (!name || !buehne) return;

    var adresse = '/collections/vendors?q=' + encodeURIComponent(name) + '&view=werke';

    fetch(adresse, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error(antwort.status);
        return antwort.text();
      })
      .then(function (html) {
        var huelle = document.createElement('div');
        huelle.innerHTML = html;
        var inhalt = huelle.querySelector('[data-kwerke-gesamt]');
        var kacheln = inhalt ? inhalt.querySelectorAll('.kwerk').length : 0;

        if (!inhalt || kacheln === 0) {
          /* Kein Werk unter diesem Namen: der Abschnitt hat nichts zu zeigen.
             Der Knopf führte dann ebenfalls ins Leere — also alles weg. */
          block.hidden = true;
          return;
        }

        buehne.textContent = '';
        buehne.appendChild(inhalt);
        block.classList.add('is-geladen');

        var gesamt = parseInt(inhalt.getAttribute('data-kwerke-gesamt'), 10);
        if (anzeige && Number.isFinite(gesamt) && gesamt > 0) {
          /* Ein- und Mehrzahl haengen als data-Attribute am Absatz selbst
             (snippets/arthene-kuenstler-werke.liquid); der deutsche Rueckfall
             greift nur, wenn eines fehlt. Im Mehrzahl-Text steht {n}. */
          var werkEins  = anzeige.getAttribute('data-werk-eins')  || '1 Werk';
          var werkViele = anzeige.getAttribute('data-werk-viele') || '{n} Werke';
          anzeige.textContent = gesamt === 1 ? werkEins : werkViele.replace('{n}', gesamt);
        }
      })
      .catch(function () {
        /* Netz weg oder Adresse geändert: lieber gar kein Abschnitt als vier
           leere Platzhalter. Der Knopf bleibt — er ist ein normaler Link. */
        var platzhalter = block.querySelector('[data-kwerke-platzhalter]');
        if (platzhalter) platzhalter.remove();
        block.classList.add('is-leer');
      });
  }

  function init(wurzel) {
    var bereich = wurzel && wurzel.querySelectorAll ? wurzel : document;
    bereich.querySelectorAll('[data-kuenstler-werke]').forEach(function (block) {
      /* Kam die Liste schon serverseitig (eigene Kategorie), ist nichts zu tun. */
      if (block.dataset.fertig === '1') return;
      laden(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  /* Im Theme-Editor wird die Section neu gezeichnet — dann noch einmal. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });

  /* Die Detailansicht des Verzeichnisses (Übergangslösung ohne Blog) baut
     ihren Werke-Block erst beim Öffnen — arthene-kuenstler.js meldet das. */
  document.addEventListener('arthene:kuenstler-detail', function (e) {
    init(e.detail && e.detail.wurzel ? e.detail.wurzel : document);
  });
})();
